import type { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyOptions = {
  fontFamily: 'Poppins, Inter, sans-serif',
  h1: { fontSize: '2rem', fontWeight: 700, lineHeight: 1.2, letterSpacing: '-0.02em' },
  h2: { fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.25, letterSpacing: '-0.02em' },
  h3: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.3 },
  h4: { fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.35 },
  h5: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.4 },
  h6: { fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.4 },
  subtitle1: { fontSize: '0.95rem', fontWeight: 600 },
  subtitle2: { fontSize: '0.8125rem', fontWeight: 600, letterSpacing: '0.02em' },
  body1: { fontSize: '0.9375rem', lineHeight: 1.7 },
  body2: { fontSize: '0.875rem', lineHeight: 1.6 },
  caption: { fontSize: '0.75rem', lineHeight: 1.5, letterSpacing: '0.03em' },
  button: { fontSize: '0.95rem', fontWeight: 600, textTransform: 'none', letterSpacing: '0.01em' },
};